const cardLazyImgRounded =
  'object-cover w-full h-full rounded-lg group-hover:opacity-80 transition ease-in-out duration-300'

const cardLazyImgRoundedTop =
  'object-cover w-full h-full rounded-t-lg group-hover:opacity-80 transition ease-in-out duration-300'

export { cardLazyImgRounded, cardLazyImgRoundedTop }
